import React from "react";

function SvgIcMapPoi047(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13 10.997V9.004h1.981V7h2.004v2.004H19v1.993h-2.015V13h-2.004v-2.003H13zm9.982 6.012l.01 1.95c-.81.428-1.81 1.094-3.385 1.545l-.606 2.396c1.328-.212 2.347-.549 3.018-.909l-.027 2.01c-1.403.51-3.56.99-6.082.99-2.34 0-4.69-.446-5.905-.99l-.014-2.006c.653.351 1.633.678 2.912.89l-.54-2.347c-1.639-.452-2.672-1.14-3.375-1.553l.034-1.938c.391.336 3.385 1.953 6.981 1.953 3.45 0 6.426-1.539 6.98-1.99zM16.116 6c4.824 0 6.902 2.032 6.902 2.032L24 13.018S21.996 14 15.997 14c-6 0-7.997-.982-7.997-.982l1.024-4.954S11.293 6 16.116 6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi047;
